import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { ConnectedRouter } from 'connected-react-router'

import store from '@redux/store'
import history from '@redux/utils/history'

import WindowDimensionsProvider from '@components/windowDimensions'

import './index.css'
import App from '@routes/'
import reportWebVitals from './reportWebVitals'

ReactDOM.render(
  <React.StrictMode>
    <WindowDimensionsProvider>
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <App />
        </ConnectedRouter>
      </Provider>
    </WindowDimensionsProvider>
  </React.StrictMode>,
  document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
